import { CalculationAlt } from '@carbon/react/icons';

import { BaseCard } from 'components/base-card';
import { CalculationIconTrigger } from 'components/calculation-icon-trigger';
import { UATNRIMatrixPopup } from './uat-nri-matrix-popup';

import type { CalculationType } from 'components/nri-table/types';

import styles from './uat-nri-matrix-card.module.scss';

interface UatNriMatrixCardProps {
  nriCalculationId: number;
  calculationType?: CalculationType;
  /** Highlight the GIS row instead of the in-use row (opened from a GIS value). */
  highlightGisRow?: boolean;
}

/**
 * Self-wrapping BaseCard around the UAT NRI Matrix popup. Mirrors
 * `TractNriMatrixCard`'s shape so call sites just render
 * `<UatNriMatrixCard nriCalculationId={…} calculationType="NRI" />` instead of
 * rebuilding the BaseCard + CalculationIconTrigger boilerplate themselves.
 *
 * @param {UatNriMatrixCardProps} props - Component props.
 * @return {JSX.Element} The rendered matrix card.
 */
export const UatNriMatrixCard = ({
  nriCalculationId,
  calculationType = 'NRI',
  highlightGisRow = false,
}: UatNriMatrixCardProps) => {
  const renderTrigger = (active: boolean, toggle: () => void) => (
    <CalculationIconTrigger
      definition="Show NRI Matrix"
      active={active}
      onClick={toggle}
    >
      <div className={styles.iconContainer}>
        <CalculationAlt aria-hidden="true" role="img" />
      </div>
    </CalculationIconTrigger>
  );

  return (
    <BaseCard
      contentClassName={styles.cardContent}
      renderTrigger={renderTrigger}
      content={
        <UATNRIMatrixPopup
          nriCalculationId={nriCalculationId}
          calculationType={calculationType}
          highlightGisRow={highlightGisRow}
        />
      }
    />
  );
};
